<div *ngFor="let contact of contacts" style="text-align: center;">
      {{ contact.fields.name }}, {{ contact.fields.email }}, {{ contact.fields.phone }}
</div>

